import type {SVGProps} from 'react'
const SvgThumbUpLarge = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      stroke="#788492"
      d="M16.5 21h-9v-9.869L9.456 8.09l.543-3.944c.045-.318.198-.608.432-.818s.532-.326.841-.327h.085c.511 0 1.002.211 1.363.586.362.375.565.884.566 1.414v4h5.143c.681 0 1.335.282 1.817.782s.753 1.178.754 1.885v4.666a4.76 4.76 0 0 1-1.32 3.299A4.43 4.43 0 0 1 16.5 21ZM3 11.5a1 1 0 0 1 1-1h3.5V21H4a1 1 0 0 1-1-1z"
    />
  </svg>
)
export default SvgThumbUpLarge
